import React from 'react';
import { TLanguageIDs, IItemForGetShortInfo, IMenuTranslation } from 'types';
import Text from 'components/Text/Text';
import LanguageBar from './components/LanguageBar';
import { NameTranslationField } from './components/NameTranslationField';
import { DescriptionTranslationField } from './components/DescriptionTranslationField';
import classNames from 'classnames';
import style from './TranslationForm.module.scss';

interface IProps {
	setTranslationTab: (value: TLanguageIDs | null) => void;
	changeNameTranslation: (languageId: TLanguageIDs, value: string) => void;
	changeDescriptionTranslation?: (languageId: TLanguageIDs, value: string) => void;
	isVisible: boolean;
	IDsSelectedLanguages: TLanguageIDs[];
	translations: IMenuTranslation[];
	selectedTranslationTab: TLanguageIDs | null;
	fetchedLanguages: IItemForGetShortInfo[];
}

export const TranslationForm: React.FC<IProps> = React.memo(
	({
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		isVisible,
		IDsSelectedLanguages,
		translations,
		selectedTranslationTab,
		fetchedLanguages,
	}) => {
		const containerClasses = classNames(style.container, { [style.visible]: isVisible });

		const languageName = fetchedLanguages.find((el) => el.id === selectedTranslationTab)?.name || null;

		return (
			<div className={containerClasses} data-test="TranslationForm">
				{translations.length ? (
					<>
						<LanguageBar
							languageIDs={IDsSelectedLanguages}
							selectedTranslationTab={selectedTranslationTab}
							setTranslationTab={setTranslationTab}
						/>
						<Text
							translationNameSpace="form"
							translationKey={languageName}
							theme="secondary"
							size="l"
							weight="bold"
						/>
						{translations.map(
							(el) =>
								el.languageId === selectedTranslationTab && (
									<React.Fragment key={el.languageId}>
										<NameTranslationField
											languageId={el.languageId}
											translations={translations}
											changeNameTranslation={changeNameTranslation}
										/>
										{changeDescriptionTranslation && (
											<DescriptionTranslationField
												languageId={el.languageId}
												translations={translations}
												changeDescriptionTranslation={changeDescriptionTranslation}
											/>
										)}
									</React.Fragment>
								),
						)}
					</>
				) : (
					<Text
						translationNameSpace="form"
						translationKey="noSelectedLanguagesHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
				)}
			</div>
		);
	},
);
